import { __ } from '@wordpress/i18n';
import {
	registerBlockType,
} from '@wordpress/blocks';
import { Button, CheckboxControl, SelectControl, TextControl, Modal, Icon} from '@wordpress/components';
import { useState } from '@wordpress/element';
import { Component } from 'react';
import TreeView from 'deni-react-treeview';
import { StyleSheet, View, ScrollView, Text } from 'react-native-web';

var nggicImageList = [];
var nggicImageViewList;
var nggicTree;

const viewStyles = StyleSheet.create({
	flexRow: {
		flex: 1,
		flexDirection: 'row'
	},
	imageView: {
		flex: 3,
		height: 500,
		width: 600,
		marginLeft: 20
	},
});

registerBlockType( 'nggic/image-chooser-block', {
    title: 'Image Chooser for NextGEN Gallery',
    icon: <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<path d="M15.5 2C18 2 20 4 20 6.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 13.39l-3.12-3.07c-.69.43-1.51.68-2.38.68C13 11 11 9 11 6.5S13 2 15.5 2m0 2A2.5 2.5 0 0 0 13 6.5A2.5 2.5 0 0 0 15.5 9A2.5 2.5 0 0 0 18 6.5A2.5 2.5 0 0 0 15.5 4m-8 10.5L4 19h14l-4.5-6l-3.5 4.5l-2.5-3M20 20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.5c-.32.77-.5 1.61-.5 2.5a6.5 6.5 0 0 0 6.5 6.5c.68 0 1.34-.11 1.96-.3L20 15.24V20z"/>
	</svg>,
    category: 'media',
	attributes: {
		insertionOption: {
			type: 'string',
		},
		template: {
			tpye: 'string',
		},
		tag: {
			type: 'string',
	        source: 'text',
	        selector: 'p',
		},
		album: {
			type: 'object',
		},
		gallery: {
			type: 'object',
		},
	},
	example: {
		attributes: {
			tag: '[nggallery id=1]',
		},
	},
	edit: ( props ) => {

		const {
			attributes: {
				insertionOption,
				template,
				tag,
				album,
				gallery
			},
			setAttributes,
		} = props;

		const [ isModalOpen, setModalOpen ] = useState( false );
		
		const openModal = function() {

			nggicImageList = [];
			jQuery.post(
					ENV.ajaxurl,
					{
				    	action: 'ajax-getOptions'
					},
					function (response) {
						setAttributes( { insertionOption: response['insertion_option'] } );
					}
			).fail(function(response) {
				alert("Error: " + response.status + '/' + response.statusText);
				return;
			});
			jQuery.post(
					ENV.ajaxurl,
					{
				    	action: 'ajax-getAlbumsAndGalleries',
				    	parent: 'root',
					},
					function (response) {
						nggicTree = response;
						setAttributes( {album: undefined, gallery: undefined, template: '' } );
						setModalOpen( true );
					}
			).fail(function(response) {
				alert("Error: " + response.status + '/' + response.statusText);
			});
		}
	
		const closeModal = () => {
			setModalOpen( false );
		}

		const selectAllImages = () => {
			nggicImageViewList.forEach(function(imageView) {
				imageView.setChecked(true);
			});
		}
		
		const unselectAllImages = () => {
			nggicImageViewList.forEach(function(imageView) {
				imageView.setChecked(false);
			});
		}
		
		const insertSelectedAlbum = () => {
			var tag = '[album id=' + album.id.substr(1) + (template.length > 0?' template="' + template + '"' : '') +  ']';
			setAttributes( { tag: tag } );
			closeModal();
		}
		
		const insertSelectedGallery = () => {
			var tag = '[nggallery id=' + gallery.id + (template.length > 0?' template="' + template + '"' : '') +  ']';
			setAttributes( { tag: tag } );
			closeModal();
		}
		
		const insertSelected = () => {
			var selectedImages = [];
			nggicImageViewList.forEach(function(imageView) {
				if (imageView.state.checked) {
					selectedImages.push(imageView.props.image.id);
				}
			});
			if (selectedImages.length > 0) {
				switch(insertionOption) {
				case 'ngg_singlepic':
					var tag = '';
					selectedImages.forEach(function(id) {
						tag = tag + '[singlepic id=' + id + (template.length > 0?' template="' + template + '"' : '') +  ']';
					});
					setAttributes( { tag: tag } );
					closeModal();
					break;
				case 'ngg_thumb':
					var tag = '';
					selectedImages.forEach(function(id) {
						tag = tag + '[thumb id=' + id + (template.length > 0?' template="' + template + '"' : '') +  ']';
					});
					setAttributes( { tag: tag } );
					closeModal();
					break;
				case 'ngg_thumb_multi':
					var ids = '';
					selectedImages.forEach(function(id) {
						ids = ids + id + ',';
					});
					var tag = '[thumb id=' + ids.substr(0, ids.length - 1) + (template.length > 0?' template="' + template + '"' : '') + ']';
					setAttributes( { tag: tag } );
					closeModal();
					break;
				default:
					alert('Unknown insertion option ' + insertionOption);
				}
			} else {
				alert('No images selected');
			}
		}
		
		const InsertOptionsSelectControl = ( ( { insertionOption, setAttributes } ) => (
		    <SelectControl
		        label="How to insert image(s)"
		        className="nggic-select"
		        value={ insertionOption }
		        options={ [
					{ label: __( 'NGG tag of image', 'nggicb' ), value: 'ngg_singlepic' },
					{ label: __( 'NGG tag of thumbnail', 'nggicb' ), value: 'ngg_thumb' },
					{ label: __( 'NGG tag of multiple thumbnails', 'nggicb' ), value: 'ngg_thumb_multi' },
		        ] }
		    	onChange={ ( insertionOption ) => { setAttributes({ insertionOption: insertionOption }) } }
		    />
		) );

		const Images = function() {
			var image_list = [];
			if (nggicImageList.length > 0) {
				nggicImageList.forEach(function(image) {
					image_list.push(
						<li key={image.id}>
							<ImageView image={ image } checked={ false } />
						</li>
					);
				});
				
				var image_area = [];
				image_area.push(<View key="buttons"><fieldset className='nggic-fieldset'><legend>Insert a NGG tag for the current gallery: { gallery.text }</legend>
				<div style={{ display: 'flex' }}>
					<Button key="btnInsertGallery" className="insert-button" onClick={ insertSelectedGallery } isPrimary="true">Insert</Button>
					<Text style={{margin: 5}}>Set the template name in &quot;Insertion Options&quot; below</Text>
				</div>
				</fieldset>
				<fieldset className='nggic-fieldset'><legend>Insertion Options</legend>
					<InsertOptionsSelectControl insertionOption={ insertionOption } setAttributes={ setAttributes } />
					<div style={{ display: 'flex' }}>
						<Text style={{margin: 5}}>Template name (Leave blank for the default template)</Text>
						<TextControl value={ template } onChange={ (template) => setAttributes({ template: template})} />
					</div>
				</fieldset>
				<fieldset className='nggic-fieldset'><legend>Press button to insert checked image(s)</legend>
				<Button key="btnInsert" className="insert-button" onClick={ insertSelected } isPrimary="true">Insert</Button>
				<Button key="btnSelectAll" onClick={ selectAllImages } isTertiary="true">Check all</Button>
				<Button key="btnUnselectAll" onClick={ unselectAllImages } isTertiary="true">Uncheck all</Button>
				</fieldset>
				</View>);
				image_area.push(<ScrollView key="svImages"><ul key="ulImages">{ image_list }</ul></ScrollView>)
				return (<>{ image_area }</>);
			} else {
				if (album) {
					return(<View key="buttons"><fieldset className='nggic-fieldset'><legend>Insert a NGG tag for the current album: { album.text }</legend>
					<TextControl label="Template name (Leave blank for the default template)" value={ template } onChange={ (template) => setAttributes({ template: template})} />
					<Button key="btnInsertAlbum" className="insert-button" onClick={ insertSelectedAlbum } isPrimary="true">Insert</Button>
					</fieldset>
					</View>);
				} else {
					return (<p>Please select a gallery to display images</p>);
				}
			}
		}
		
		const onSelectItem = item => {
			if (item.isLeaf) {
				jQuery.post(
						ENV.ajaxurl,
						{
					    	action: 'ajax-getImages',
					    	gallery: item.id,
						},
						function (response) {
							nggicImageList = response;
							nggicImageViewList = [];
							setAttributes( { gallery: item } );
						}
				).fail(function(response) {
					alert("Error: " + response.status + '/' + response.statusText);
				});
			} else {
				setAttributes( { album: item } );
			}
		 }
		
		const SelectModal = () => (
			<Modal
				title="Image Chooser for NextGEN Gallery"
				onRequestClose={ closeModal }
			>
			    <View style={ viewStyles.flexRow }>
		    		<TreeView key="tree" className='nggic-tree' items={ nggicTree } onSelectItem = {onSelectItem} />
			        <View key="images" style={viewStyles.imageView}>
		        	    { Images() }
		        	</View>
		        </View>
		    </Modal>
		);

		const NggicIcon = () => (<Icon icon={
			<svg>
				<path d="M15.5 2C18 2 20 4 20 6.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 13.39l-3.12-3.07c-.69.43-1.51.68-2.38.68C13 11 11 9 11 6.5S13 2 15.5 2m0 2A2.5 2.5 0 0 0 13 6.5A2.5 2.5 0 0 0 15.5 9A2.5 2.5 0 0 0 18 6.5A2.5 2.5 0 0 0 15.5 4m-8 10.5L4 19h14l-4.5-6l-3.5 4.5l-2.5-3M20 20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.5c-.32.77-.5 1.61-.5 2.5a6.5 6.5 0 0 0 6.5 6.5c.68 0 1.34-.11 1.96-.3L20 15.24V20z"/>
			</svg>
		} />);

		return (
			<>
			    <View style={ viewStyles.flexRow }>
					<Button isPrimary='true' icon={NggicIcon} onClick={ openModal }>{ __( 'Select images or gallery', 'nggicb' ) }</Button>
					<p style={{marginTop: 0, marginBottom: 0, marginLeft: 20}}>{ tag && ('Present tag(s): ' + tag) }</p>
				</View>
				{ isModalOpen && (
					SelectModal()
				) }
			</>
 		);
	},
	save: ( props ) => {
		const {
			attributes: {
				tag,
			},
		} = props;
		
		return (
			<p>{ tag }</p>
		);
	},
} );

class ImageView extends Component {

	constructor(props) {
		super(props);
		this.state = { checked: props.checked };
		this.image = props.image;
		this.instance = this;
	}

	componentDidMount() {
		nggicImageViewList.push(this.instance);
		this.instance.setChecked = (checked) => {
			this.setState({ checked: checked });     
		};
	}

	render() {
		return (
			<View key={'image-view-' + this.image.id} style={ viewStyles.flexRow }>
				<View key={'thumb-view-' + this.image.id} style={{ flex: 1, backgroundImage: 'url(' + this.image.thumbnail_src + ')', backgroundRepeat: 'no-repeat', height: '160px' }}>
					<CheckboxControl
						key={'checkbox' - this.image.id}
						checked={this.state.checked}
						onChange={(checked) => {
							this.setState({ checked: checked });
						}}
					/>
				</View>
				<View key={'meta-view-' + this.image.id} style={{ flex: 2 }}>
					<p>Title: {this.image.title}</p>
					<p>Description: {this.image.description}</p>
				</View>
			</View>
		);
	}

}